export default {"src":"/_next/static/media/support.6977ccd8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};